interface ResponsiveImageProps extends React.HTMLAttributes<HTMLImageElement> {
    picture?: string | { src: string; width: number }[];
}

export const ResponsiveImage = ({ picture, ...props }: ResponsiveImageProps) => {
    return (
        <div {...props}>
            {typeof picture === 'string' ? (
                <img src={picture} alt="" />
            ) : Array.isArray(picture) ? (
                <picture>
                    {picture
                        .slice()
                        .reverse()
                        .map((p) => (
                            <source key={p.width} media={`(min-width: points.${p.width}px)`} srcSet={p.src} />
                        ))}
                    <img src={picture[0].src} alt="" />
                </picture>
            ) : null}
        </div>
    );
};
